<template>
  <el-dialog
    v-if="this.isCreate() || this.isUpdate()"
    width="71%"
    top="2%"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :title="titleModal"
    :visible.sync="internalVisible"
    @close="handleClose()"
  >
    <loading
      :active.sync="isLoadingZone"
      :can-cancel="false"
      :color="'#f18f00'"
      :is-full-page="false"
      :height="100"
      :width="255"
      :opacity="0.8"
    >
    </loading>
    <div class="row">
      <div class="col-12">
        <span style="font-size: 15px; word-break: break-word">
          1. {{ $t('common_words.zone_info_message') }}
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
          clearable
          @clear="pagination1.perPage = 5"
          class="select-default mb-3 shadow-sm"
          style="width: 200px"
          v-model="pagination1.perPage"
          :placeholder="$t('common_words.per_page')"
          filterable
        >
          <el-option
            class="select-default"
            v-for="item in pagination1.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-input
          clearable
          class="mb-3 shadow-sm"
          style="width: 200px"
          :placeholder="$t('common_words.search_records')"
          v-model="searchQuery1"
          aria-controls="datatables"
        />
      </div>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
      >
        <div class="col-12">
          <div class="row my-2">
            <div class="col-12 pr-0">
              <a @click="addZoneRow" style="cursor: pointer">
                <em class="fa fa-plus" style="color: #2891b0"></em
                >{{ $t('common_words.add_record') }}
              </a>
            </div>
          </div>
          <el-table
            v-if="queriedData.length > 0 || addZone == 0"
            style="width: 100%"
            :data="queriedData"
            :border="true"
          >
            <el-table-column
              prop="businesses_id"
              :label="`${$t('common_words.companies2')}`"
            >
              <template slot-scope="scope">
                <el-select
                  @change="
                    selectAllFromSelect(
                      scope.row.businesses_id,
                      businesses,
                      scope
                    )
                  "
                  clearable
                  multiple
                  collapse-tags
                  class="select-primary custom-width-select nut-rels shadow-sm"
                  size="large"
                  v-model="scope.row.businesses_id"
                  :placeholder="`${$t('common_words.select')}...`"
                  filterable
                >
                  <el-option
                    v-for="(option, index) in businesses"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id + '_' + index"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="name" :label="$t('common_words.name')">
              <template slot-scope="scope">
                <el-input
                  maxlength="60"
                  show-word-limit
                  clearable
                  size="small"
                  style="text-align: center"
                  v-model="scope.row.name"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="30"
              :label="$t('common_words.actions')"
            >
              <template slot-scope="scope">
                <a
                  v-if="isCreate()"
                  :finish-button-text="$t('common_words.save')"
                  class="btn-success btn-simple btn-link actions-box-category-save"
                  @click="storeUpdateZone(scope.$index, scope.row, true)"
                  ><em class="fa fa-floppy-o"></em>
                </a>
                <a
                  v-if="addZone > 1 && isDelete()"
                  v-tooltip.top-center="$t('common_words.delete')"
                  class="btn-danger btn-simple btn-link"
                  slot="reference"
                  @click="deleteZone(scope.$index, scope.row, true)"
                >
                  <em class="fa fa-times"></em>
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <p class="card-category" style="font-size: 14px">
            {{ $t('table2.showing') }} {{ from1 + 1 }} {{ $t('table2.a') }}
            {{ to1 }} {{ $t('table2.of') }} {{ total1 }}
            {{ $t('table2.entries') }}
          </p>
        </div>
        <l-pagination
          class="pagination-no-border"
          ref="paginationZone"
          v-model="pagination1.currentPage"
          :per-page="pagination1.perPage"
          :total="pagination1.total"
          pageFirst="false"
          pageLast="false"
        >
        </l-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import Loading from 'vue-loading-overlay';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create-zone',
  props: {
    zoneCreation: { type: Boolean, default: false },
    titleModal: { type: String, default: '' },
  },
  components: {
    Loading,
  },
  data() {
    return {
      tableData1: [],
      searchQuery1: '',
      fuseSearch1: null,
      pagination1: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      businesses: [],
      isLoadingZone: false,
      addZone: 0,
      zoneForm: {
        businesses_id: [],
        businesses_names: [],
        name: null,
      },
    };
  },
  mixins: [
    mixinMasters,
    MixinLoading,
    MixinPermissions,
    MixinAlert,
    MixinNotification,
  ],
  computed: {
    internalVisible: {
      get() {
        return this.zoneCreation;
      },
      set(val) {
        this.$emit('update:zoneCreation', val);
      },
    },
    queriedData() {
      let result = this.tableData1;
      if (this.searchQuery1 !== '') {
        result = this.fuseSearch1.search('=' + this.searchQuery1 + '');
      }
      this.pagination1.total = result.length;
      return result.slice(this.from1, this.to1);
    },
    pagedData1() {
      return this.tableData1.slice(this.from1, this.to1);
    },
    to1() {
      let highBound = this.from1 + this.pagination1.perPage;
      if (this.total1 < highBound) {
        highBound = this.total1;
      }

      return highBound;
    },
    from1() {
      return this.pagination1.perPage * (this.pagination1.currentPage - 1);
    },
    total1() {
      this.pagination1.total = this.tableData1.length;

      return this.tableData1.length;
    },
  },
  methods: {
    searchFuse1(keys) {
      this.fuseSearch1 = new Fuse(this.tableData1, {
        useExtendedSearch: true,
        threshold: 0.3,
        keys: keys,
      });
      this.showHideLoading();
    },
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    handleClose() {
      this.$emit('update:zoneCreation', false);
    },
    addZoneRow() {
      let newRow = { type: '', visible: false };
      this.tableData1 = [...this.tableData1, newRow];
      ++this.addZone;
      setTimeout(() => {
        this.pagination1.currentPage = this.$refs.paginationZone.maxPage;
      }, 150);
    },
    getNameOfData(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },
    updateBusinessSelect() {
      this.tableData1.forEach((zone, index) => {
        if (isset(zone.businesses) && zone.businesses.length > 0) {
          const businessIds = zone.businesses.map((b) => b.id);
          this.$set(this.tableData1[index], 'businesses_id', businessIds);
        } else {
          this.tableData1.splice(index, 1);
        }
      });
    },
    storeUpdateZone(index, row, closeModal = false) {
      if (isset(row.name) && row.businesses_id.length > 0) {
        this.isLoadingZone = true;
        this.zoneForm = row;
        this.zoneForm.route = 'zone';
        this.zoneForm.businesses_names = this.getNameOfData(
          this.zoneForm.businesses_id,
          this.businesses
        );

        if (isset(row.id)) {
          Axios.updateMaster(this.zoneForm)
            .then((response) => {
              let indexRow = this.tableData1.findIndex(
                (tableRow) => tableRow.id === this.zoneForm.id
              );
              this.$set(this.tableData1, indexRow, response.data.data);
              this.isLoadingZone = false;
              this.updateBusinessSelect();
              if (closeModal) this.handleClose();
              SweetAlert.success(response.data.message);
              this.$emit('zonesUpdate', this.tableData1);

              return true;
            })
            .catch((error) => {
              if (closeModal) this.handleClose();
              this.showMessageErrors(error);

              return false;
            });
        } else {
          Axios.saveMaster(this.zoneForm)
            .then((response) => {
              this.$set(this.tableData1, index, {
                ...response.data.data,
              });
              this.updateBusinessSelect();
              this.isLoadingZone = false;
              if (closeModal) this.handleClose();
              SweetAlert.success(response.data.message);
              this.$emit('zonesUpdate', this.tableData1);

              return true;
            })
            .catch((error) => {
              if (closeModal) this.handleClose();
              this.showMessageErrors(error);

              return false;
            });
        }
      } else if (!isset(row.name)) {
        SweetAlert.warning(i18n.t('common_words.name_required'));

        return false;
      } else if (row.businesses_id.length == 0) {
        SweetAlert.warning(i18n.t('common_words.company_selection_required'));

        return false;
      }

      return true;
    },
    deleteZone(index, row) {
      if (isset(row.id)) {
        this.zoneForm = row;
        this.zoneForm.route = 'zone';
        this.zoneForm.id = row.id;
        SweetAlert.delete(i18n.t('common_words.zone')).then((result) => {
          if (result.value) {
            this.isLoadingZone = true;
            Axios.destroyMaster(this.zoneForm)
              .then((response) => {
                SweetAlert.success(i18n.t('common_words.successful_deletion'));
                this.tableData1 = response.data.data;
                this.updateBusinessSelect();
                this.$emit('zonesUpdate', this.tableData1);
              })
              .catch((error) => {
                this.showMessageErrors(error);
              });
            this.isLoadingZone = false;
            this.tableData1.splice(index, 1);
            this.addZone--;
          }
        });
      } else {
        this.tableData1.splice(index, 1);
        this.addZone--;
      }
    },
  },
  mounted() {
    this.isLoadingZone = true;
    Promise.all([
      Axios.getMasters('businesses/only'),
      Axios.getMasters('zones'),
    ])
      .then(([responseBusinesses, responseZones]) => {
        this.businesses = this.concatAll(responseBusinesses.data.data);
        this.tableData1 = responseZones.data.data;
        if (this.tableData1.length > 0) {
          this.addZone = this.tableData1.length;
          this.updateBusinessSelect();
          this.searchFuse1(['name']);
        }
        this.showHideLoading();
        this.isLoadingZone = false;
      })
      .catch((error) => this.showMessageErrors(error));
  },
};
</script>
